"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Throbber = _interopRequireDefault(require("../Throbber"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ELEMENT_TYPES = {
  DIV: 'div',
  IMG: 'img'
};
var STATES = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded'
};
var PreloadImage = /*#__PURE__*/function (_React$PureComponent) {
  function PreloadImage(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PreloadImage);
    _this = _callSuper(this, PreloadImage, [props]);
    _this.state = {
      state: STATES.INITIAL,
      isClient: false
    };
    _this.imageRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  (0, _inherits2["default"])(PreloadImage, _React$PureComponent);
  return (0, _createClass2["default"])(PreloadImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.mounted = true;
      this.setState({
        isClient: true
      }, function () {
        _this2.load();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "src",
    get: function get() {
      var _this$props = this.props,
        src = _this$props.src,
        src2x = _this$props.src2x,
        src3x = _this$props.src3x;
      var _ref = window || {},
        devicePixelRatio = _ref.devicePixelRatio;
      if (devicePixelRatio >= 3 && src3x) {
        return src3x;
      }
      if (devicePixelRatio >= 2 && src2x) {
        return src2x;
      }
      return src;
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;
      this.setState({
        state: STATES.LOADING
      });
      var _this$props2 = this.props,
        src = _this$props2.src,
        onLoad = _this$props2.onLoad,
        elementType = _this$props2.elementType;
      var canceled = false;
      var image = elementType === ELEMENT_TYPES.DIV ? new Image() : this.imageRef.current;
      var handler = function handler() {
        if (!canceled && _this3.mounted) {
          _this3.setState({
            state: STATES.LOADED
          });
          onLoad();
        }
      };
      image.addEventListener('load', handler);
      image.addEventListener('error', handler);
      image.src = src;
      if (image.complete) {
        canceled = true;
        if (this.mounted) {
          this.setState({
            state: STATES.LOADED
          });
          onLoad();
        }
        image.removeEventListener('load', handler);
        image.removeEventListener('error', handler);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        state = _this$state.state,
        isClient = _this$state.isClient;
      var _this$props3 = this.props,
        className = _this$props3.className,
        elementType = _this$props3.elementType,
        showThrobber = _this$props3.showThrobber,
        srcSet = _this$props3.srcSet;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
        className: className
      }, !isClient ? /*#__PURE__*/_react["default"].createElement(StyledPreloader, null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showThrobber && state === STATES.LOADING && /*#__PURE__*/_react["default"].createElement(StyledPreloader, null), elementType === ELEMENT_TYPES.DIV ? /*#__PURE__*/_react["default"].createElement(StyledImage, {
        style: {
          backgroundImage: "url(".concat(this.src, ")"),
          opacity: state === STATES.LOADING ? 0 : 1
        }
      }) : /*#__PURE__*/_react["default"].createElement(StyledImg, {
        ref: this.imageRef,
        src: this.src,
        srcSet: srcSet,
        alt: ""
      })));
    }
  }]);
}(_react["default"].PureComponent);
PreloadImage.defaultProps = {
  onLoad: Function.prototype,
  elementType: ELEMENT_TYPES.DIV,
  srcSet: null,
  showThrobber: false,
  className: '',
  src2x: null,
  src3x: null
};
PreloadImage.propTypes = {
  className: _propTypes["default"].string,
  src: _propTypes["default"].string.isRequired,
  src2x: _propTypes["default"].string,
  src3x: _propTypes["default"].string,
  srcSet: _propTypes["default"].string,
  onLoad: _propTypes["default"].func,
  elementType: _propTypes["default"].oneOf([ELEMENT_TYPES.DIV, ELEMENT_TYPES.IMG]),
  showThrobber: _propTypes["default"].bool
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "PreloadImage__StyledContainer",
  componentId: "sc-54gkqa-0"
})(["position:relative;width:100%;height:100%;"]);
var StyledImage = _styledComponents["default"].div.withConfig({
  displayName: "PreloadImage__StyledImage",
  componentId: "sc-54gkqa-1"
})(["width:100%;height:100%;margin:0 auto;display:block;background-size:contain;background-position:center;background-repeat:no-repeat;transition:opacity 120ms ease;"]);
var StyledImg = _styledComponents["default"].img.withConfig({
  displayName: "PreloadImage__StyledImg",
  componentId: "sc-54gkqa-2"
})(["height:100%;"]);
var StyledPreloader = (0, _styledComponents["default"])(_Throbber["default"]).withConfig({
  displayName: "PreloadImage__StyledPreloader",
  componentId: "sc-54gkqa-3"
})(["width:100%;height:100%;margin:0 auto;display:block;position:absolute;"]);
PreloadImage.Image = StyledImage;
var _default = exports["default"] = PreloadImage;